// Alchemer returns quota names URL-encoded, but a name typed by hand or pasted
// from a bulk-upload sheet can contain a bare '%' (e.g. "SEG C2DE 45%").
// decodeURIComponent throws URIError on those, and a throw inside render
// unmounts the whole tree — so fall back to the raw string instead of taking
// the page down over a cosmetic decode.
export const safeDecode = (value) => {
  if (typeof value !== 'string') return value ?? '';
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export default safeDecode;
